import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilService, VariablesService } from '../../../../shared/services';
import { IFundraiser } from 'src/app/shared/models/fundraiser.model';
import { ABService } from 'src/app/shared/services/ab/ab.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() public fundraiser: IFundraiser;
  @Input() public theaterImg;
  @Input() public isFundraiserEnded;
  @Output() public watchVideo = new EventEmitter();
  isMobile: any;
  today = new Date();
  constructor(
    public AB: ABService,
    public utilService: UtilService,
    public vars: VariablesService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

  /**Scroll to appealing video section */
  scrollToVideo() {
    this.watchVideo.emit(true);
  }

  getTheaterImage() {
    if (this.fundraiser) {
      return this.fundraiser?.gallery[0].cdn_path;
    }
    return this.utilService.defaultImg;
  }

}
